import { Product } from "@~/types/types.ts";
import { useState } from "react";
import styles from "@~/product-card-components/QuickView/QuickView.module.scss";
import { SecondaryButton } from "@JohnLewisPartnership/jl-design-system/dist/components/button/Button";
import { QuickViewModal } from "@~/product-card-components/__shared__/QuickViewModal/QuickViewModal.tsx";

type Props = {
  product: Product;
  handleButtonClick?: () => void;
  config?: string | undefined;
};

export function QuickViewButton({ product, handleButtonClick }: Props) {
  const [showQuickView, setShowQuickView] = useState(false);

  const handleClick = () => {
    if (handleButtonClick) {
      handleButtonClick();
    }
    setShowQuickView(true);
  };

  return (
    <>
      <SecondaryButton
        className={styles["quick-view-button"]}
        onClick={handleClick}
        labelText="Quick View"
      />
      {showQuickView && (
        <QuickViewModal
          product={product}
          showModal={true}
          onClose={() => setShowQuickView(false)}
          originator={undefined}
        />
      )}
    </>
  );
}
